import PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";
import { Link as RouterLink } from "react-router";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";

// nav config
import navigation from "@nualang/nualang-ui-components/dist/Navigation/_nav";

const useStyles = makeStyles()((theme) => ({
  listItem: {
    borderRadius: theme.shape.borderRadius,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textTransform: "capitalize",
    transition: "background-color 0.5s ease",
  },
}));

function Library({
  Link = RouterLink,
  t = (text) => text,
  links = navigation.sideNav[1].links,
}) {
  const { classes } = useStyles();
  return (
    <>
      <List component='div'>
        {links.map((item, index) => {
          return (
            <ListItem
              button
              key={index}
              className={`${classes.listItem}`}
              component={Link}
              to={item.url}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={t(item.name)} />
            </ListItem>
          );
        })}
      </List>
      <Divider />
    </>
  );
}

Library.propTypes = {
  t: PropTypes.func.isRequired,
  links: PropTypes.array.isRequired,
};

export default Library;
